<app-dialog-header [title]="'FORM.SELECT_CONTENT_STRUCTURE.TITLE'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <span class="pb-16">{{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.CONTENT_STRUCTURE_CHANGED' | translate }}</span>
    <form [formGroup]="moduleFormService.moduleContentForm" class="w-100-p" fxLayout="column">
        <mat-radio-group fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="20px" formControlName="structure" (change)="handleChange($event)">
            <div class="radio-wrapper" fxLayout="column" fxLayoutAlign="center" fxLayoutGap="23px">
                <mat-radio-button [value]="true"> {{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.SECTIONS_CONTENT' | translate }} </mat-radio-button>
                <img src="/assets/icons/ic_sections_and_content.svg" />
            </div>
            <div class="radio-wrapper" fxLayout="column" fxLayoutAlign="center" fxLayoutGap="23px">
                <mat-radio-button [value]="false">{{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.CONTENT_ONLY' | translate }} </mat-radio-button>
                <img src="/assets/icons/ic_content_only.svg" />
            </div>
        </mat-radio-group>

        <div class="checkbox-wrapper mt-32">
            <span class="block pb-16">{{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.TRACKING_PROGRESS_CHANGED' | translate }}</span>
            <mat-radio-group fxLayout="column" formControlName="rule">
                <mat-radio-button class="mb-8" [value]="ruleOpts.dontTrackProgress">
                    {{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.DONT_TRACK_PROGRESS' | translate }}
                </mat-radio-button>
                <mat-radio-button class="mb-8" [value]="ruleOpts.trackProgress" [disabled]="isDisablesTrackOptions">
                    {{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.TRACK_PROGRESS' | translate }}
                </mat-radio-button>
                <mat-radio-button [value]="ruleOpts.sequential" [disabled]="isDisablesTrackOptions">
                    {{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.TRACK_PROGRESS_AND_ENABLE_SEQUENTIAL_ACCESS' | translate }}
                </mat-radio-button>
                <span class="description">{{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.SEQUENTIAL_DESCRIPTION' | translate }}</span>
            </mat-radio-group>
        </div>
    </form>
</div>
<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [label]="'GENERAL.BUTTON.SELECT'" (onClick)="saveSelected()"></app-flat-button>
</div>
